import * as requestFromServer from './pasoCincoCrud';

import { pasoCincoSlice, callTypes } from './pasoCincoSlice';
//import { fetchInscripciones } from '../inscripcion/inscripcionActions';

const { actions } = pasoCincoSlice;

export const fetchPasoCinco = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoCinco(queryParams)
        .then(response => {
            const pasoCincoInformacion = response.data;
            //console.log(pasoCuatroAlTresInformacion);
            dispatch(actions.pasoCincoFetched({ pasoCincoInformacion }));
            //dispatch(fetchInscripciones());
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchErrorPasoCinco({ error, callType: callTypes.action }));
        });
};

export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.stateLimpiar());
};